import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';

import { MatDialog, MatDialogRef } from '@angular/material/dialog'

import { ClientSociUpdate, ClientSociElement } from '../../../utes/utes.interfaces';
import { ClientsSocisService } from '../../../services/clients_socis/clientsSocis.service';
import { ClientsSocisUTEsService } from '../../../services/clients_socis/clientsSocisUTEs.service';

import { IClientsSocis, IClientsSocisResponse } from '../../../clientsSocis/clientssocis.interfaces';

@Component({
  selector: 'mcrit-gestio-manage-utes-socis-list',
  templateUrl: './clients-socis-list.component.html',
  styleUrls: ['clients-socis-list.component.css'],
  providers:[ ClientsSocisService, ClientsSocisUTEsService ]
})

export class ClientsSocisListUTEsComponent implements OnInit {
  @Input() showAsyncProgress: boolean = false;
  @Input('clientsSocisList') clientsSocisList: Array <any> = [];
  @Input('idUTEs') idCodi: any;
  @Output() changeFilter = new EventEmitter();
  //@Output() deleteClientSoci: EventEmitter<ClientSociUpdate> = new EventEmitter();

  public availableClientsSocis: Array<ClientSociElement> = [];
  public allClientsSocis: Array<ClientSociElement> = [];
  
  public showEditor: boolean = false;
  public error: any;
  public txFiltre: string = '';

  public newClientSociId: string = '';
  public newCPercPart: string = '';
  private clientSociModel: IClientsSocis = {
      'id': 'NEW',
      'nom': null,
      'tipus': null,
      'telefon': null,
      'adreca': null,
      'client': true,
      'soci': true,
      'localitzacio': null,
      'descripcio': null,
      'comentari': null,
      'web': null,
      'mail': null,
      'country': null,
      'cif': null
  };

  public editClientSociData: IClientsSocis;
  
  public trackItem (index: number, item: any) {
   return item;
  }

  public addOrUpdateClientSoci(): void {
    this.showAsyncProgress = true;
    if (this.editClientSociData.id === 'NEW') {
      this.clientsSocisUTEsService.createSoci(this.editClientSociData)
        .subscribe(newClientSoci => {console.log("S'ha creat l'element");
          this.selClientsSocis();
          this.showAsyncProgress = false;
      });
    };
  }

  public updateSociUte(): void {
    let sociToAdd = null;

    if (!this.newClientSociId || this.newClientSociId === '')return;
    this.clientsSocisUTEsService.updateSociUte(this.newClientSociId, this.idCodi, this.newCPercPart)
    .subscribe(updatedData => {
       this.showEditor = false;
       this.changeFilter.emit();
    });
  }

  public deleteSociUte(id): void {
    this.clientsSocisUTEsService.deleteSociUte(id, this.idCodi)
    .subscribe(updatedData => {
       this.showEditor = false;
       this.changeFilter.emit();
    });
  }

  public openEditor(): void {
    this.showEditor = true;
    this.newClientSociId = '';
    this.selClientsSocis();
  }

  public closeEditor() {
    this.showEditor = false;
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, private clientsSocisUTEsService: ClientsSocisUTEsService, private clientsSocisService: ClientsSocisService, public dialog: MatDialog, protected router: Router ){}

  public filterClientSocis(){
    if(!this.txFiltre)this.availableClientsSocis = this.allClientsSocis ;
    else this.availableClientsSocis = 
         this.allClientsSocis.filter(item => item['nom'].toLowerCase().includes(this.txFiltre.toLowerCase()))
  }

  private selClientsSocis() {
    this.clientsSocisService.get('Socis', this.idCodi)
      .subscribe(
        list => {
          this.allClientsSocis = list;
          if(!this.txFiltre)this.availableClientsSocis = list;
          else this.availableClientsSocis = this.allClientsSocis.filter((v,i) => this.availableClientsSocis.findIndex(item => item["nom"] == v["nom"]) === i);
        },
        err => console.log(err)
      );
  }

  ngOnInit(){this.selClientsSocis();}
}
